import { motion } from 'framer-motion';
import React,{useState} from 'react'

const ErrorMessage = ({ error,message,classKey }) => {
    return (
        <motion.p
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            className={classKey?classKey:"itext-f4 text-sm font-semibold text-[#FC4523] mt-[16px] login-err"}
        >
            {error && message}
        </motion.p>
    );
};
export default ErrorMessage;
